import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=16767910&ts=true"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/UpdatePasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16767910"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16767910', __exports__)) {
    api.reload('16767910', __exports__)
  }
  
  module.hot.accept("./UpdatePasswordForm.vue?vue&type=template&id=16767910&ts=true", () => {
    api.rerender('16767910', render)
  })

}


export default __exports__